import React from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import BoostedJackpotInitialPopupWinners from '../boostedJackpotInitialPopupWinners';
import BoostedJackpotPopupDate from '../../boostedJackpotPopupDate';
import { applicationStore } from '../../../../../store/applicationStore';
import { userInfoStore } from '../../../../../store/userInfoStore';
import { isMobile } from '../../../../../core/helpers/isMobile';
import { setTranslationValues } from '../../../../../core/helpers/setTranslationValues';
import { isoStandard } from '../../../../../core/helpers/isoStandard';

function BoostedJackpotInitialPopupView({
  handlePointerOut,
  handlePointerMove,
  handlePointerDown,
  handleClickButtons,
  boostedJackpotInitialPopup,
  boostedJackpotPopupCloseButton,
  boostedJackpotInfoPopupOkButton,
}) {
  const { limits, currencySymbol } = userInfoStore;
  // eslint-disable-next-line no-shadow
  const { canvasTranslationKeys } = applicationStore;

  return (
    <Container name='BoostedJackpotInitialPopupView'>
      <Sprite texture={boostedJackpotInitialPopup} anchor={0} />
      <Sprite
        anchor={0}
        interactive
        cursor='pointer'
        pointerup={() => handleClickButtons(false)}
        texture={boostedJackpotPopupCloseButton}
        x={710}
        y={15}
      />
      <BoostedJackpotInitialPopupWinners x={320} y={119} />
      <BoostedJackpotPopupDate
        x={193}
        y={245}
        marginInText={46}
        marginInContainer={110}
        hiderTextXPosition={23}
        durationTextPositions={{ x: 190, y: 18 }}
        stylesTimer={{
          _fontSize: 36,
          _fontWeight: 700,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          letterSpacing: 21,
        }}
      />
      <Container
        interactive
        cursor='pointer'
        pointerout={handlePointerOut}
        pointermove={isMobile() ? () => {} : handlePointerMove}
        pointerdown={handlePointerDown}
        pointerup={() => handleClickButtons(true)}
        x={270}
        y={424}
      >
        <Sprite texture={boostedJackpotInfoPopupOkButton} anchor={0} />
        <Text
          x={95}
          y={33}
          anchor={0.5}
          text={canvasTranslationKeys.OK}
          style={{
            _fontSize: 30,
            _fontWeight: 700,
            _fontFamily: 'poppinsMedium',
            _fill: '#F5F7FC',
            align: 'center',
            _wordWrap: true,
            _wordWrapWidth: 206,
          }}
          resolution={2}
        />
      </Container>
      <Text
        x={364}
        y={400}
        anchor={0.5}
        text={setTranslationValues(`${canvasTranslationKeys.POP_UP_TEXT}`, {
          VALUE: `${isoStandard(limits.boostedJackpotBetAmount)} ${currencySymbol}`,
        })}
        style={{
          _fontSize: 14,
          _fontWeight: 400,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          _wordWrap: true,
          _wordWrapWidth: 500,
        }}
        resolution={2}
      />
    </Container>
  );
}

export default BoostedJackpotInitialPopupView;
